document.addEventListener("DOMContentLoaded", function () {
  // Scope all behaviour to the new-main-product section(s) so quick buy / other product blocks are not affected
  const sectionRoots = document.querySelectorAll('section.product-showcase-wrapper[id^="new-main-product-"]');
  sectionRoots.forEach(function (sectionRoot) {
    const sectionId = sectionRoot.id.replace(/^new-main-product-/, '');
    const productData = window.newMainProductData && window.newMainProductData[sectionId];
    let productThumbsSwiper = null; // section-scoped; variant gallery updates use this

    // ========================================
    // VARIANT SWITCHING FUNCTIONALITY
    // ========================================
    if (productData && productData.variants) {
    const enableAnimations = productData.enable_animations === true;

    // Detect color option
    let colorOptionName = '';
    let colorOptionIndex = -1;

    if (productData.options && productData.options.length > 0) {
      productData.options.forEach((option, index) => {
        const optionNameLower = option.name.toLowerCase();
        if (optionNameLower.includes('color') || optionNameLower.includes('colour')) {
          colorOptionName = option.name;
          colorOptionIndex = index;
        }
      });
    }

    // Build variant gallery by color (normalized lowercase key) when using variant gallery metafield
    const variantGalleriesByColor = {};
    if (productData.use_variant_gallery_metafield && Array.isArray(productData.variant_gallery_entries)) {
      productData.variant_gallery_entries.forEach(function (entry) {
        if (entry && entry.color != null) {
          const key = String(entry.color).trim().toLowerCase();
          variantGalleriesByColor[key] = entry.media || [];
        }
      });
    }
    const useVariantGalleryMetafield = productData.use_variant_gallery_metafield === true && Object.keys(variantGalleriesByColor).length > 0;

    // [DEBUG] Variant gallery metafield
    console.log('[Variant Gallery] productData.use_variant_gallery_metafield:', productData.use_variant_gallery_metafield);
    console.log('[Variant Gallery] productData.variant_gallery_entries:', productData.variant_gallery_entries);
    console.log('[Variant Gallery] productData.variant_gallery_entries length:', productData.variant_gallery_entries ? productData.variant_gallery_entries.length : 0);
    if (productData.variant_gallery_entries && productData.variant_gallery_entries[0]) {
      console.log('[Variant Gallery] first entry sample:', { color: productData.variant_gallery_entries[0].color, mediaLength: (productData.variant_gallery_entries[0].media && productData.variant_gallery_entries[0].media.length) || 0, mediaSample: (productData.variant_gallery_entries[0].media && productData.variant_gallery_entries[0].media[0]) || null });
    }
    console.log('[Variant Gallery] variantGalleriesByColor keys:', Object.keys(variantGalleriesByColor));
    console.log('[Variant Gallery] variantGalleriesByColor:', variantGalleriesByColor);
    console.log('[Variant Gallery] useVariantGalleryMetafield:', useVariantGalleryMetafield);

    // Only proceed if we have variant-based colors (scoped to this section)
    const colorSection = sectionRoot.querySelector('.color-section[data-color-type="variant"]');
    console.log('[Variant Gallery] colorSection found:', !!colorSection, 'colorOptionIndex:', colorOptionIndex);
    if (colorSection && colorOptionIndex !== -1) {
      console.log('[Variant Gallery] Variant color section active — variant switching (and variant gallery) will run.');
      // Build variant map by color
      const variantsByColor = {};
      productData.variants.forEach(variant => {
        const colorValue = variant.options[colorOptionIndex];
        if (!variantsByColor[colorValue]) {
          variantsByColor[colorValue] = [];
        }
        variantsByColor[colorValue].push(variant);
      });
      
      // Get current variant from URL or default
      let currentVariant = productData.variants.find(v => v.id === productData.selected_variant_id);
      if (!currentVariant) {
        currentVariant = productData.variants.find(v => v.available) || productData.variants[0];
      }
      
      // Check URL for variant parameter
      const urlParams = new URLSearchParams(window.location.search);
      const variantIdFromUrl = urlParams.get('variant');
      if (variantIdFromUrl) {
        const urlVariant = productData.variants.find(v => v.id === parseInt(variantIdFromUrl));
        if (urlVariant) {
          currentVariant = urlVariant;
        }
      }
      
      // Helper function to format money
      function formatMoney(cents) {
        if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
          return Shopify.formatMoney(cents, window.theme?.moneyFormat || '${{amount}}');
        }
        const amount = (cents / 100).toFixed(2);
        return '$' + amount;
      }
      
      // Function to filter and show only sizes for current color
      function filterSizesByColor(colorValue) {
        const sizeOptions = sectionRoot.querySelectorAll('.size-options .size-label-button');
        
        // First, check if any variant with this color is available
        const colorVariants = productData.variants.filter(v => v.options[colorOptionIndex] === colorValue);
        const hasAvailableVariant = colorVariants.some(v => v.available);
        
        sizeOptions.forEach(sizeLabel => {
          const input = sizeLabel.querySelector('input');
          const variantId = parseInt(input.value);
          const variant = productData.variants.find(v => v.id === variantId);
          
          if (variant) {
            const variantColor = variant.options[colorOptionIndex];

            if (variantColor === colorValue) {
              // ELEGATTO DEV — always show sizes of current color; cross out unavailable instead of hiding — May 2026
              sizeLabel.style.display = '';
              if (variant.available) {
                sizeLabel.classList.remove('unavailable');
                input.disabled = false;
              } else {
                sizeLabel.classList.add('unavailable');
                input.disabled = false;
              }
            } else {
              // Hide sizes from other colors
              sizeLabel.style.display = 'none';
            }
          }
        });
        
        // Remove loading class to make container visible
        const sizeOptionsContainer = sectionRoot.querySelector('.size-options');
        if (sizeOptionsContainer) {
          sizeOptionsContainer.classList.remove('sizes-loading');
        }
      }
      
      // Function to update all product information
      function updateProductInfo(variant, skipAnimation = false) {
        if (!variant) return;
        
        const shouldAnimate = enableAnimations && !skipAnimation;
        
        // Update button state immediately (no animation delay)
        const addToCartButton = sectionRoot.querySelector('.add-to-cart-button');
        const stickyAddToCartButton = sectionRoot.querySelector('.sticky-add-to-cart-button');
        
        const buttonText = variant.available ? 
          (productData.translations?.addToCart || 'Add to Cart') : 
          (productData.translations?.soldOut || 'Sold Out');
        
        if (addToCartButton) {
          addToCartButton.textContent = buttonText;
          addToCartButton.disabled = !variant.available;
        }
        
        if (stickyAddToCartButton) {
          stickyAddToCartButton.textContent = buttonText;
          stickyAddToCartButton.disabled = !variant.available;
        }
        // ELEGATTO DEV C3 — swap ATC ↔ Notify Me May 2026  
        const bisAnchor = sectionRoot.querySelector('.elegatto-bis-anchor');
        if (bisAnchor) {
          if (variant.available) {
            try { var _u = new URL(location.href); _u.searchParams.set('variant', variant.id); history.replaceState({}, '', _u); } catch(e){}
            bisAnchor.style.display = 'none';
            if (addToCartButton) addToCartButton.style.display = '';
          } else {
            bisAnchor.setAttribute('data-variant', variant.id);
            bisAnchor.setAttribute('data-product', productData.id);
            try { var _u = new URL(location.href); _u.searchParams.set('variant', variant.id); history.replaceState({}, '', _u); } catch(e){}
            bisAnchor.style.display = '';
            if (addToCartButton) addToCartButton.style.display = 'none';
          }
        }
        
        // Add animation class
        const priceSection = sectionRoot.querySelector('.price-section');
        const productGallery = sectionRoot.querySelector('.product-gallery');
        const mainImageMobile = sectionRoot.querySelector('.main-image');
        
        if (shouldAnimate) {
          if (priceSection) priceSection.classList.add('transitioning');
          if (productGallery) productGallery.classList.add('transitioning');
          if (mainImageMobile) mainImageMobile.classList.add('transitioning');
        }
        
        // Update price section
        setTimeout(() => {
          if (priceSection) {
            let priceHTML = '';
            if (variant.compare_at_price && variant.compare_at_price > variant.price) {
              const savings = variant.compare_at_price - variant.price;
              priceHTML = `
                <span class=\"original-price\">${formatMoney(variant.compare_at_price)}</span>
                <span class=\"sale-price\">${formatMoney(variant.price)}</span>
                <span class=\"save-badge\">SAVE ${formatMoney(savings)}</span>
              `;
            } else {
              priceHTML = `<span class=\"sale-price\">${formatMoney(variant.price)}</span>`;
            }
            priceSection.innerHTML = priceHTML;
          }
          
          // Update images - variant gallery metafield (by color) or standard product/variant images
          const colorOptionIdx = productData.color_option_index != null ? productData.color_option_index : colorOptionIndex;
          const colorValueRaw = variant.options[colorOptionIdx];
          const colorValueNormalized = colorValueRaw != null ? String(colorValueRaw).trim().toLowerCase() : '';
          const mediaForColor = useVariantGalleryMetafield && colorValueNormalized ? (variantGalleriesByColor[colorValueNormalized] || []) : null;
          const hasVariantGalleryMedia = mediaForColor && mediaForColor.length > 0;

          // [DEBUG] Per-variant color lookup
          console.log('[Variant Gallery] updateProductInfo variant.id:', variant.id, 'options:', variant.options);
          console.log('[Variant Gallery] colorOptionIdx:', colorOptionIdx, 'colorValueRaw:', JSON.stringify(colorValueRaw), 'colorValueNormalized:', JSON.stringify(colorValueNormalized));
          console.log('[Variant Gallery] mediaForColor:', mediaForColor, 'length:', mediaForColor ? mediaForColor.length : 0, 'hasVariantGalleryMedia:', hasVariantGalleryMedia);
          console.log('[Variant Gallery] taking path:', useVariantGalleryMetafield ? (hasVariantGalleryMedia ? 'variant-gallery-media' : 'variant-gallery-fallback') : 'standard-product-images');

          function isVideoMedia(item) {
            if (!item) return false;
            const mt = (item.media_type || '').toLowerCase();
            const url = item.url || '';
            return mt === 'video' || /\.(mp4|webm|ogg)(\?|$)/i.test(url);
          }

          if (useVariantGalleryMetafield) {
            // Variant gallery metafield path: show media for color or fallback to single variant image
            const mediaToShow = hasVariantGalleryMedia ? mediaForColor : [];
            const productGalleryEl = sectionRoot.querySelector('.product-gallery');
            const imageContainers = productGalleryEl ? productGalleryEl.querySelectorAll('.product-image-container') : [];
            const mainMediaWrapper = sectionRoot.querySelector('.product-swiper-mobile');
            const mainMedia = mainMediaWrapper ? mainMediaWrapper.querySelector('.main-image, .main-media-video') : null;
            const thumbsWrapper = sectionRoot.querySelector('.product-thumbs-swiper .swiper-wrapper');

            if (hasVariantGalleryMedia) {
              // Desktop: update up to 4 containers with img or video
              const desktopMedia = mediaToShow.slice(0, 4);
              desktopMedia.forEach(function (item, index) {
                const container = imageContainers[index];
                if (!container) return;
                const isVideo = isVideoMedia(item);
                const url = item.url || '';
                const previewUrl = item.preview_url || item.preview_image?.url || url;
                let el = container.querySelector('.gallery-thumb, .gallery-media-video');
                if (isVideo) {
                  if (!el || !el.classList.contains('gallery-media-video')) {
                    container.innerHTML = '';
                    el = document.createElement('video');
                    el.className = 'product-image gallery-thumb gallery-media-video';
                    el.setAttribute('width', '400');
                    el.setAttribute('height', '400');
                    el.muted = true;
                    el.loop = true;
                    el.playsInline = true;
                    el.setAttribute('poster', previewUrl);
                    const source = document.createElement('source');
                    source.src = url;
                    source.setAttribute('type', 'video/mp4');
                    el.appendChild(source);
                    container.appendChild(el);
                  }
                  el.setAttribute('data-index', index);
                  el.setAttribute('data-full-src', previewUrl);
                  el.setAttribute('data-video-src', url);
                  el.setAttribute('poster', previewUrl);
                  var srcEl = el.querySelector('source');
                  if (srcEl) srcEl.src = url;
                } else {
                  if (!el || el.classList.contains('gallery-media-video')) {
                    container.innerHTML = '';
                    el = document.createElement('img');
                    el.className = 'product-image gallery-thumb';
                    el.setAttribute('width', '400');
                    el.setAttribute('height', '400');
                    el.loading = 'lazy';
                    container.appendChild(el);
                  }
                  el.setAttribute('data-index', index);
                  el.setAttribute('data-full-src', url);
                  el.src = url;
                }
              });
              // Hide extra containers
              for (var i = desktopMedia.length; i < imageContainers.length; i++) {
                if (imageContainers[i]) imageContainers[i].classList.add('product-image-container--hidden');
              }
              for (var j = 0; j < desktopMedia.length; j++) {
                if (imageContainers[j]) imageContainers[j].classList.remove('product-image-container--hidden');
              }

              // Mobile main: img or video
              if (mainMediaWrapper && mainMedia) {
                const firstItem = mediaToShow[0];
                const firstIsVideo = isVideoMedia(firstItem);
                const firstUrl = firstItem.url || '';
                const firstPreview = firstItem.preview_url || firstItem.preview_image?.url || firstUrl;
                if (firstIsVideo) {
                  if (mainMedia.tagName !== 'VIDEO') {
                    const video = document.createElement('video');
                    video.className = 'main-image main-media-video';
                    video.setAttribute('width', '100%');
                    video.setAttribute('height', '376');
                    video.controls = true;
                    video.muted = false;
                    video.loop = true;
                    video.playsInline = true;
                    video.setAttribute('poster', firstPreview);
                    video.setAttribute('data-video-src', firstUrl);
                    var s = document.createElement('source');
                    s.src = firstUrl;
                    s.setAttribute('type', 'video/mp4');
                    video.appendChild(s);
                    mainMediaWrapper.replaceChild(video, mainMedia);
                  } else {
                    mainMedia.setAttribute('poster', firstPreview);
                    mainMedia.setAttribute('data-video-src', firstUrl);
                    var src = mainMedia.querySelector('source');
                    if (src) src.src = firstUrl;
                  }
                } else {
                  if (mainMedia.tagName !== 'IMG') {
                    const img = document.createElement('img');
                    img.className = 'main-image';
                    img.setAttribute('width', '100%');
                    img.setAttribute('height', '376');
                    img.loading = 'lazy';
                    img.alt = productData.title || '';
                    img.src = firstUrl;
                    mainMediaWrapper.replaceChild(img, mainMedia);
                  } else {
                    mainMedia.src = firstUrl;
                  }
                }
                var currentMain = mainMediaWrapper.querySelector('.main-image, .main-media-video');
                if (currentMain && currentMain.tagName === 'VIDEO') {
                  currentMain.muted = true;
                  currentMain.play().catch(function() {});
                }
              }

              // Mobile thumbs: rebuild slides
              if (thumbsWrapper && productThumbsSwiper) {
                thumbsWrapper.innerHTML = '';
                mediaToShow.forEach(function (item, idx) {
                  const isVideo = isVideoMedia(item);
                  const thumbSrc = item.preview_url || item.preview_image?.url || item.url || '';
                  const largeSrc = item.url || '';
                  const slide = document.createElement('div');
                  slide.className = 'swiper-slide' + (idx === 0 ? ' activated' : '');
                  slide.setAttribute('data-slide-index', idx);
                  slide.setAttribute('data-media-type', isVideo ? 'video' : 'image');
                  slide.setAttribute('data-large-src', largeSrc);
                  slide.setAttribute('data-poster-url', thumbSrc);
                  const thumbImg = document.createElement('img');
                  thumbImg.src = thumbSrc;
                  thumbImg.alt = productData.title || '';
                  thumbImg.className = 'thumb-image';
                  thumbImg.loading = 'lazy';
                  slide.appendChild(thumbImg);
                  thumbsWrapper.appendChild(slide);
                });
                if (productThumbsSwiper.updateSlides) productThumbsSwiper.updateSlides();
                if (productThumbsSwiper.update) productThumbsSwiper.update();
                productThumbsSwiper.slideTo(0, 0, false);
              }
            } else {
              // Fallback: only default variant image
              const fallbackSrc = variant.featured_image && variant.featured_image.src
                ? (variant.featured_image.src.split('?')[0] + '?width=400')
                : (productData.images && productData.images[0] ? productData.images[0].src : '');
              const fallbackFull = variant.featured_image && variant.featured_image.src
                ? variant.featured_image.src.split('?')[0]
                : (productData.images && productData.images[0] ? productData.images[0].src : '');
              if (imageContainers[0]) {
                imageContainers[0].classList.remove('product-image-container--hidden');
                var existing = imageContainers[0].querySelector('.gallery-thumb, .gallery-media-video');
                if (existing && existing.tagName === 'VIDEO') {
                  imageContainers[0].innerHTML = '';
                  existing = null;
                }
                var imgEl = imageContainers[0].querySelector('.gallery-thumb');
                if (!imgEl) {
                  imgEl = document.createElement('img');
                  imgEl.className = 'product-image gallery-thumb';
                  imgEl.setAttribute('width', '400');
                  imgEl.setAttribute('height', '400');
                  imgEl.loading = 'lazy';
                  imageContainers[0].appendChild(imgEl);
                }
                imgEl.setAttribute('data-index', '0');
                imgEl.setAttribute('data-full-src', fallbackFull);
                imgEl.src = fallbackSrc;
                for (var k = 1; k < imageContainers.length; k++) {
                  imageContainers[k].classList.add('product-image-container--hidden');
                }
              }
              if (mainMedia && mainMedia.tagName === 'IMG') {
                mainMedia.src = fallbackFull;
              } else if (mainMediaWrapper) {
                var fallbackImg = document.createElement('img');
                fallbackImg.className = 'main-image';
                fallbackImg.setAttribute('width', '100%');
                fallbackImg.setAttribute('height', '376');
                fallbackImg.loading = 'lazy';
                fallbackImg.alt = productData.title || '';
                fallbackImg.src = fallbackFull;
                if (mainMedia) mainMediaWrapper.replaceChild(fallbackImg, mainMedia);
              }
              if (thumbsWrapper && productThumbsSwiper) {
                thumbsWrapper.innerHTML = '';
                var fallbackSlide = document.createElement('div');
                fallbackSlide.className = 'swiper-slide activated';
                fallbackSlide.setAttribute('data-slide-index', '0');
                fallbackSlide.setAttribute('data-media-type', 'image');
                fallbackSlide.setAttribute('data-large-src', fallbackFull);
                var fi = document.createElement('img');
                fi.src = fallbackSrc;
                fi.alt = productData.title || '';
                fi.className = 'thumb-image';
                fi.loading = 'lazy';
                fallbackSlide.appendChild(fi);
                thumbsWrapper.appendChild(fallbackSlide);
                if (productThumbsSwiper.updateSlides) productThumbsSwiper.updateSlides();
                if (productThumbsSwiper.update) productThumbsSwiper.update();
                productThumbsSwiper.slideTo(0, 0, false);
              }
            }

            if (typeof rebuildModalImages === 'function') rebuildModalImages();
            if (typeof setupDesktopGalleryHandlers === 'function') setupDesktopGalleryHandlers();
          } else {
            // Standard path: variant image or product images
            let imagesToShow = [];
            if (variant.featured_image && variant.featured_image.src) {
              imagesToShow.push(variant.featured_image);
              const otherImages = productData.images.filter(function (img) { return img.id !== variant.featured_image.id; });
              imagesToShow = imagesToShow.concat(otherImages);
            } else {
              imagesToShow = productData.images || [];
            }
            const desktopImages = imagesToShow.slice(0, 4);
            const mobileImages = imagesToShow;

            if (productGallery) {
              const imageContainers = productGallery.querySelectorAll('.product-image-container');
              desktopImages.forEach(function (image, index) {
                if (imageContainers[index]) {
                  const img = imageContainers[index].querySelector('.product-image');
                  if (img && image && image.src) {
                    const imageUrl = image.src.includes('?') ? image.src.split('?')[0] : image.src;
                    img.src = imageUrl + '?width=400';
                    img.setAttribute('data-full-src', imageUrl);
                    img.setAttribute('data-index', index);
                  }
                }
              });
              if (typeof rebuildModalImages === 'function') rebuildModalImages();
              if (typeof setupDesktopGalleryHandlers === 'function') setupDesktopGalleryHandlers();
            }
            if (mainImageMobile && mobileImages[0] && mobileImages[0].src) {
              const imageUrl = mobileImages[0].src.includes('?') ? mobileImages[0].src.split('?')[0] : mobileImages[0].src;
              mainImageMobile.src = imageUrl;
            }
            if (skipAnimation === false && variant.featured_image && productData.images) {
              const thumbSlides = sectionRoot.querySelectorAll('.product-thumbs-swiper .swiper-slide');
              const variantImageId = variant.featured_image.id;
              let matchingIndex = -1;
              thumbSlides.forEach(function (slide, index) {
                if (slide.getAttribute('data-image-id') == variantImageId) matchingIndex = index;
              });
              if (matchingIndex >= 0) {
                thumbSlides.forEach(function (s) { s.classList.remove('activated'); });
                thumbSlides[matchingIndex].classList.add('activated');
                const img = thumbSlides[matchingIndex].querySelector('img');
                if (img && mainImageMobile) {
                  const largeSrc = img.getAttribute('data-large-src');
                  if (largeSrc) mainImageMobile.src = largeSrc;
                }
                if (productThumbsSwiper) productThumbsSwiper.slideTo(matchingIndex, 300, false);
              }
            }
          }

          
          // Update hidden variant ID input
          const hiddenInput = sectionRoot.querySelector('.product-form input[name=\"id\"]');
          if (hiddenInput) {
            hiddenInput.value = variant.id;
          }
          
          // Update sticky cart variant ID
          const stickyInput = sectionRoot.querySelector('.sticky-product-form input[name=\"id\"]');
          if (stickyInput) {
            stickyInput.value = variant.id;
          }
          
          // Update URL without reload
          const newUrl = new URL(window.location.href);
          newUrl.searchParams.set('variant', variant.id);
          window.history.replaceState({ variantId: variant.id }, '', newUrl);
          
          // Remove animation class
          if (shouldAnimate) {
            setTimeout(() => {
              if (priceSection) priceSection.classList.remove('transitioning');
              if (productGallery) productGallery.classList.remove('transitioning');
              if (mainImageMobile) mainImageMobile.classList.remove('transitioning');
            }, 50);
          }
        }, shouldAnimate ? 150 : 0);
      }
      
      // Color option click handler
      const colorOptions = colorSection.querySelectorAll('.color-option');
      colorOptions.forEach(colorOption => {
        colorOption.addEventListener('click', function(e) {
          e.preventDefault();

          // ELEGATTO DEV — May 2026: разрешаем выбор полностью распроданного цвета,
          // чтобы для него показался Notify Me (свап делает updateProductInfo, как на size-level OOS)

          const colorValue = this.getAttribute('data-color-value');
          const selectedColorSpan = colorSection.querySelector('[data-selected-color]');
          
          // Update selected color text
          if (selectedColorSpan) {
            selectedColorSpan.textContent = colorValue;
          }
          
          // Update active state
          colorOptions.forEach(opt => opt.classList.remove('activated'));
          this.classList.add('activated');
          
          // Filter sizes by this color
          filterSizesByColor(colorValue);
          
          // Find best matching variant
          const colorVariants = variantsByColor[colorValue] || [];
          let selectedVariant = null;
          
          // Try to preserve current size/other options
          const currentOptions = currentVariant.options.slice();
          currentOptions[colorOptionIndex] = colorValue;
          
          // Look for exact match (same size, new color)
          selectedVariant = colorVariants.find(v => {
            return v.options.every((opt, idx) => opt === currentOptions[idx]);
          });
          
          // If no exact match, find first available with this color
          if (!selectedVariant) {
            selectedVariant = colorVariants.find(v => v.available);
          }
          
          // If no available, just get first with this color
          if (!selectedVariant) {
            selectedVariant = colorVariants[0];
          }
          
          if (selectedVariant) {
            currentVariant = selectedVariant;
            
            // Update size selection
            const sizeOptions = sectionRoot.querySelectorAll('.size-options .size-label-button');
            sizeOptions.forEach(sizeLabel => {
              const input = sizeLabel.querySelector('input');
              const variantId = parseInt(input.value);
              
              if (variantId === selectedVariant.id) {
                input.checked = true;
                sizeLabel.classList.add('selected');
                
                // Update the size-selected display with the new variant's full title
                const sizeSelected = sectionRoot.querySelector('.size-label .size-selected');
                if (sizeSelected) {
                  const variantTitle = input.getAttribute('data-variant-option') || selectedVariant.title;
                  sizeSelected.textContent = variantTitle;
                }
              } else {
                input.checked = false;
                sizeLabel.classList.remove('selected');
              }
            });
            
            updateProductInfo(selectedVariant, false);
          }
        });
      });
      
      // Size option click handler
      const sizeOptions = sectionRoot.querySelectorAll('.size-options .size-label-button');
      sizeOptions.forEach(sizeLabel => {
        sizeLabel.addEventListener('click', function() {
          const input = this.querySelector('input');
          if (input && !input.disabled) {
            const variantId = parseInt(input.value);
            const variant = productData.variants.find(v => v.id === variantId);
            
            if (variant) {
              currentVariant = variant;
              
              // Update selection visual
              sizeOptions.forEach(label => label.classList.remove('selected'));
              this.classList.add('selected');
              
              updateProductInfo(variant);
            }
          }
        });
      });
      
      // Initialize on page load - show only sizes for current color
      if (currentVariant) {
        const currentColor = currentVariant.options[colorOptionIndex];
        filterSizesByColor(currentColor);
        
        // Update the size-selected display on initial load
        const sizeSelected = sectionRoot.querySelector('.size-label .size-selected');
        if (sizeSelected) {
          sizeSelected.textContent = currentVariant.title;
        }
        
        updateProductInfo(currentVariant, true); // Skip animation on initial load
      }
    } else {
      console.log('[Variant Gallery] Variant color section NOT active (no .color-section[data-color-type="variant"] or no color option). Variant gallery JS will not run.');
    }
    }

    // ========================================
    // EXISTING CODE BELOW (scoped to sectionRoot)
    // ========================================

    // Key Features Accordion
    const toggle = sectionRoot.querySelector("#key-features-toggle");
  const content = sectionRoot.querySelector("#key-features-content");
  const icon = toggle ? toggle.querySelector(".key-features-icon") : null;
  if (toggle && content && icon) {
    toggle.addEventListener("click", function () {
      const isExpanded = this.getAttribute("aria-expanded") === "true";
      this.setAttribute("aria-expanded", !isExpanded);
      content.setAttribute("aria-hidden", isExpanded);
      icon.textContent = !isExpanded ? "−" : "+";
    });
  }

  // Anchor Accordions
  sectionRoot.querySelectorAll('.product-anchors .anchor-item').forEach(function(anchor) {
    anchor.addEventListener('click', function(e) {
      e.preventDefault();

      const target = anchor.getAttribute('data-target').trim();
      const scopedAccordionItems = sectionRoot.querySelectorAll('#accordion-wrapper .accordion-container .accordion-item');
      const accordionItems = scopedAccordionItems.length
        ? scopedAccordionItems
        : document.querySelectorAll('#accordion-wrapper .accordion-container .accordion-item');

      function smoothScrollTo(targetNode) {
        if (!targetNode) return;
        const rect = targetNode.getBoundingClientRect();
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        window.scrollTo({
          top: rect.top + scrollTop - 174,
          behavior: 'smooth'
        });
      }

      if (/^\d+$/.test(target)) {
        const index = parseInt(target, 10) - 1;
        const targetItem = accordionItems[index]
          || sectionRoot.querySelector(`#accordion-wrapper .accordion-container .accordion-item[data-index="${index}"]`)
          || document.querySelector(`#accordion-wrapper .accordion-container .accordion-item[data-index="${index}"]`);
        const targetTitle = targetItem ? targetItem.querySelector('.accordion-title') : null;
        if (!targetTitle || !targetItem) return;

        if (!targetItem.classList.contains('active')) {
          targetTitle.dataset.skipAccordionAutoScroll = '1';
          targetTitle.click();
          targetTitle.removeAttribute('data-skip-accordion-auto-scroll');
        }
        smoothScrollTo(targetItem);
      } else {
        const idElem = target === '#features'
          ? (sectionRoot.querySelector('#features') || document.querySelector('#features'))
          : (sectionRoot.querySelector(target) || document.querySelector(target));
        if (!idElem) return;

        const header = idElem.querySelector('.key-features-header');
        if (header && header.getAttribute('aria-expanded') === "false") {
          header.click();
        }

        smoothScrollTo(idElem);
      }
    });
  });

  // Size Options Toggle and Show Selected Size
  const sizeLabels = sectionRoot.querySelectorAll(".size-options label.size-label-button");
  const sizeSelected = sectionRoot.querySelector(".size-label .size-selected");

  sizeLabels.forEach((label) => {
    let fullText = label.textContent.trim();
    label.setAttribute("data-full-size", fullText);
  });

  // Rename Size Options (visual only)
  sizeLabels.forEach((label) => {
    let text = label.textContent.trim();
    let newText = text.split("(")[0].trim();
    const input = label.querySelector("input");
    label.textContent = "";
    if (input) label.appendChild(input);
    label.appendChild(document.createTextNode(" " + newText));
  });

  function updateSizeSelected(label) {
    if (sizeSelected && label) {
      sizeSelected.textContent = label.getAttribute("data-full-size") || "";
    }
  }
  
  // Check if there's already a selected size (from Liquid template or variant switching)
  const alreadySelected = sectionRoot.querySelector(".size-options label.size-label-button.selected");
  
  if (!alreadySelected && sizeLabels.length > 0) {
    // Only auto-select first if nothing is already selected
    sizeLabels[0].classList.add("selected");
    updateSizeSelected(sizeLabels[0]);
  } else if (alreadySelected) {
    // Update the size-selected text for the already-selected option
    updateSizeSelected(alreadySelected);
  }
  
  sizeLabels.forEach((label) => {
    label.addEventListener("click", function () {
      sizeLabels.forEach((l) => l.classList.remove("selected"));
      this.classList.add("selected");
      updateSizeSelected(this);
    });
  });

  // Swiper Thumbs Gallery
  const mainImage = sectionRoot.querySelector(".main-image");
  const thumbsSwiperContainer = sectionRoot.querySelector(".product-thumbs-swiper");
  if (mainImage && thumbsSwiperContainer && typeof Swiper !== "undefined") {
    const thumbsSwiper = new Swiper(thumbsSwiperContainer, {
      slidesPerView: "auto",
      spaceBetween: 8,
      freeMode: true,
      centeredSlides: false,
      slideToClickedSlide: true,
      watchSlidesProgress: true,
      scrollbar: {
        el: ".swiper-scrollbar",
        draggable: true,
        hide: false,
      },
    });
    
    // Store in closure for this section (variant gallery updates use this)
    productThumbsSwiper = thumbsSwiper;
    
    const slides = thumbsSwiperContainer.querySelectorAll(".swiper-slide");
    
    // Find the activated slide and scroll to it on initialization
    const activatedIndex = Array.from(slides).findIndex(slide => slide.classList.contains('activated'));
    if (activatedIndex >= 0) {
      thumbsSwiper.slideTo(activatedIndex, 0, false); // 0 = no animation, false = no callbacks
    }
    
    // Thumb click: event delegation so dynamically rebuilt variant-gallery thumbs work
    thumbsSwiperContainer.addEventListener("click", function (e) {
      const slide = e.target.closest(".swiper-slide");
      if (!slide) return;
      const allSlides = thumbsSwiperContainer.querySelectorAll(".swiper-slide");
      const index = Array.from(allSlides).indexOf(slide);
      allSlides.forEach(function (s) { s.classList.remove("activated"); });
      slide.classList.add("activated");
      const mediaType = slide.getAttribute("data-media-type");
      const largeSrc = slide.getAttribute("data-large-src") || (slide.querySelector("img") && slide.querySelector("img").getAttribute("data-large-src"));
      const mainMediaWrapper = sectionRoot.querySelector(".product-swiper-mobile");
      let mainMedia = mainMediaWrapper ? mainMediaWrapper.querySelector(".main-image, .main-media-video") : null;
      if (largeSrc && mainMediaWrapper) {
        if (mediaType === "video") {
          if (!mainMedia || mainMedia.tagName !== "VIDEO") {
            mainMedia = document.createElement("video");
            mainMedia.className = "main-image main-media-video";
            mainMedia.setAttribute("width", "100%");
            mainMedia.setAttribute("height", "376");
            mainMedia.controls = true;
            mainMedia.loop = true;
            mainMedia.playsInline = true;
            var srcEl = document.createElement("source");
            srcEl.src = largeSrc;
            srcEl.setAttribute("type", "video/mp4");
            mainMedia.appendChild(srcEl);
            var old = mainMediaWrapper.querySelector(".main-image, .main-media-video");
            if (old) mainMediaWrapper.replaceChild(mainMedia, old); else mainMediaWrapper.insertBefore(mainMedia, mainMediaWrapper.firstChild);
          } else {
            var s = mainMedia.querySelector("source");
            if (s) s.src = largeSrc;
          }
          mainMedia.setAttribute("poster", slide.getAttribute("data-poster-url") || largeSrc);
          mainMedia.muted = true;
          mainMedia.play().catch(function() {});
        } else {
          if (!mainMedia || mainMedia.tagName !== "IMG") {
            mainMedia = document.createElement("img");
            mainMedia.className = "main-image";
            mainMedia.setAttribute("width", "100%");
            mainMedia.setAttribute("height", "376");
            mainMedia.loading = "lazy";
            mainMedia.alt = "";
            var old = mainMediaWrapper.querySelector(".main-image, .main-media-video");
            if (old) mainMediaWrapper.replaceChild(mainMedia, old); else mainMediaWrapper.insertBefore(mainMedia, mainMediaWrapper.firstChild);
          }
          mainMedia.src = largeSrc;
        }
        if (productThumbsSwiper) productThumbsSwiper.slideTo(index, 300, false);
        mainMedia = mainMediaWrapper ? mainMediaWrapper.querySelector(".main-image, .main-media-video") : null;
        if (mainMedia && mainMedia.tagName === "VIDEO") {
          mainMedia.muted = true;
          mainMedia.play().catch(function() {});
        }
      }
    });
  }

  // Review Swiper (scoped to this section)
  const reviewSwiperEl = sectionRoot.querySelector(".swiper-container.review-highlight");
  const reviewsSwiper = reviewSwiperEl && typeof Swiper !== "undefined" ? new Swiper(reviewSwiperEl, {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next",
    },
    watchOverflow: true,
    noSwiping: false,
    breakpoints: {
      768: {
        slidesPerView: 1,
        spaceBetween: 20,
      },
    },
    on: {
      slideChange: function () {
        const nextBtn = sectionRoot.querySelector(".swiper-button-next");
        if (this.isEnd) {
          nextBtn.classList.add("disabled");
        } else {
          nextBtn.classList.remove("disabled");
        }
      },
    },
  }) : null;

  if (reviewsSwiper) {
    document.addEventListener("DOMContentLoaded", function () {
      reviewsSwiper.emit("slideChange");
    });
  }

  // Gallery Modal (global scope so modal works wherever it is in the DOM)
  const modal = document.getElementById("gallery-modal");
  const modalMediaContainer = modal ? modal.querySelector("#modal-media-container") : null;
  const modalMediaWrapper = modal ? modal.querySelector("#modal-media-wrapper") : null;
  const modalImage = modal ? modal.querySelector("#modal-main-image") : null;
  const currentIndexSpan = modal ? modal.querySelector(".current-index") : null;
  const totalImagesSpan = modal ? modal.querySelector(".total-images") : null;
  let productImages = [];
  let productModalItems = [];
  let currentIndex = 0;
  let viewportSyncBound = false;
  let modalImageZoomed = false;
  const modalMobileZoomScale = 2;
  let modalZoomX = 0;
  let modalZoomY = 0;
  let modalPanActive = false;
  let modalPanStartX = 0;
  let modalPanStartY = 0;
  let modalPanStartZoomX = 0;
  let modalPanStartZoomY = 0;
  let modalPanMoved = false;
  let modalGestureBound = false;

  function syncModalViewportHeight() {
    if (!modal) return;
    if (window.innerWidth >= 1024) {
      modal.style.removeProperty("--modal-vh");
      return;
    }
    const vv = window.visualViewport;
    // When user pinches (scale != 1), visualViewport height can fluctuate
    // and break fixed overlays. Fall back to innerHeight to keep layout stable.
    const viewportHeight = vv && vv.scale === 1 ? vv.height : window.innerHeight;
    modal.style.setProperty("--modal-vh", `${Math.round(viewportHeight)}px`);
  }

  function resetModalImageZoom() {
    if (!modalMediaContainer) {
      modalImageZoomed = false;
      return;
    }
    const activeMedia = modalMediaContainer.querySelector(".modal-main-image");
    if (!activeMedia) {
      modalImageZoomed = false;
      return;
    }
    activeMedia.classList.remove("is-zoomed");
    activeMedia.style.transform = "";
    activeMedia.style.transformOrigin = "";
    activeMedia.style.cursor = "";
    modalImageZoomed = false;
    modalZoomX = 0;
    modalZoomY = 0;
    modalPanActive = false;
    modalPanMoved = false;
  }

  function clampModalZoomOffset(img, x, y, scale) {
    const rect = img.getBoundingClientRect();
    const maxX = Math.max(0, ((rect.width * scale) - rect.width) / 2);
    const maxY = Math.max(0, ((rect.height * scale) - rect.height) / 2);
    return {
      x: Math.max(-maxX, Math.min(maxX, x)),
      y: Math.max(-maxY, Math.min(maxY, y))
    };
  }

  function applyModalZoomTransform(img) {
    if (!img) return;
    const clamped = clampModalZoomOffset(img, modalZoomX, modalZoomY, modalMobileZoomScale);
    modalZoomX = clamped.x;
    modalZoomY = clamped.y;
    img.style.transform = `translate(${modalZoomX}px, ${modalZoomY}px) scale(${modalMobileZoomScale})`;
  }

  function bindModalImageTapZoom(img) {
    if (!img) return;
    img.style.transformOrigin = "50% 50%";

    img.addEventListener("pointerdown", function (e) {
      if (!modalImageZoomed) return;
      modalPanActive = true;
      modalPanMoved = false;
      modalPanStartX = e.clientX;
      modalPanStartY = e.clientY;
      modalPanStartZoomX = modalZoomX;
      modalPanStartZoomY = modalZoomY;
      img.style.cursor = "grabbing";
      if (img.setPointerCapture) img.setPointerCapture(e.pointerId);
      e.preventDefault();
      e.stopPropagation();
    });

    img.addEventListener("pointermove", function (e) {
      if (!modalImageZoomed || !modalPanActive) return;
      const dx = e.clientX - modalPanStartX;
      const dy = e.clientY - modalPanStartY;
      if (Math.abs(dx) > 3 || Math.abs(dy) > 3) modalPanMoved = true;
      modalZoomX = modalPanStartZoomX + dx;
      modalZoomY = modalPanStartZoomY + dy;
      applyModalZoomTransform(img);
      e.preventDefault();
      e.stopPropagation();
    });

    function endPan(e) {
      if (!modalPanActive) return;
      modalPanActive = false;
      img.style.cursor = "grab";
      if (e && img.releasePointerCapture) {
        try { img.releasePointerCapture(e.pointerId); } catch (_) {}
      }
    }

    img.addEventListener("pointerup", endPan);
    img.addEventListener("pointercancel", endPan);
    img.addEventListener("pointerleave", endPan);

    img.addEventListener("click", function (e) {
      if (!modal || modal.style.display !== "flex") return;
      if (modalPanMoved) {
        modalPanMoved = false;
        return;
      }

      const rect = img.getBoundingClientRect();
      if (!rect.width || !rect.height) return;

      if (!modalImageZoomed) {
        const relX = (e.clientX - rect.left) - (rect.width / 2);
        const relY = (e.clientY - rect.top) - (rect.height / 2);
        modalZoomX = -relX * (modalMobileZoomScale - 1);
        modalZoomY = -relY * (modalMobileZoomScale - 1);
        applyModalZoomTransform(img);
        img.classList.add("is-zoomed");
        img.style.cursor = "grab";
        modalImageZoomed = true;
      } else {
        resetModalImageZoom();
      }

      e.preventDefault();
      e.stopPropagation();
    });
  }

  function shouldBlockNativePinch() {
    return !!(modal && modal.style.display === "flex" && window.innerWidth < 1024);
  }

  function blockNativePinchGesture(e) {
    if (shouldBlockNativePinch()) {
      e.preventDefault();
    }
  }

  // Function to rebuild productImages and productModalItems from current gallery
  function rebuildModalImages() {
    productImages = [];
    productModalItems = [];
    const mobileThumbsSwiper = sectionRoot.querySelector('.product-thumbs-swiper');
    const isMobile = window.innerWidth < 1024 && mobileThumbsSwiper && window.getComputedStyle(mobileThumbsSwiper).display !== 'none';

    if (isMobile) {
      sectionRoot.querySelectorAll(".product-thumbs-swiper .swiper-slide").forEach((slide) => {
        const posterUrl = slide.getAttribute("data-poster-url");
        const largeSrc = slide.getAttribute("data-large-src");
        const mediaType = slide.getAttribute("data-media-type");
        const img = slide.querySelector("img");
        const src = (posterUrl || largeSrc || (img && (img.getAttribute("data-large-src") || img.src))) || "";
        if (src) {
          productImages.push(src);
          productModalItems.push(mediaType === "video" ? { type: "video", src: src, videoSrc: largeSrc || src } : { type: "image", src: src });
        }
      });
    } else {
      // Only include visible desktop gallery items so modal order matches and we don't include empty placeholders
      sectionRoot.querySelectorAll(".product-gallery .product-image-container:not(.product-image-container--hidden)").forEach((container) => {
        const el = container.querySelector(".gallery-thumb, .gallery-media-video");
        if (!el) return;
        const isVideo = el.tagName === "VIDEO" || el.classList.contains("gallery-media-video");
        const fullSrc = el.getAttribute("data-full-src") || el.getAttribute("poster") || (el.src || "") || "";
        let videoSrc = el.getAttribute("data-video-src") || "";
        if (isVideo && !videoSrc) {
          const sourceEl = el.querySelector("source");
          if (sourceEl && sourceEl.src) videoSrc = sourceEl.src;
        }
        if (fullSrc || videoSrc) {
          productImages.push(fullSrc || videoSrc);
          productModalItems.push(isVideo ? { type: "video", src: fullSrc, videoSrc: videoSrc || fullSrc } : { type: "image", src: fullSrc });
        }
      });
    }

    if (totalImagesSpan) totalImagesSpan.textContent = productImages.length;
    if (currentIndex >= productImages.length) currentIndex = 0;
  }

  rebuildModalImages();

  function openModal(index) {
    currentIndex = index;
    updateImage();
    // Keep modal fixed to the real viewport (iOS Safari can clip fixed inside section containers)
    if (modal && !modal.dataset.portalized) {
      document.body.appendChild(modal);
      modal.dataset.portalized = "true";
    }
    syncModalViewportHeight();
    if (!viewportSyncBound) {
      window.addEventListener("resize", syncModalViewportHeight);
      window.addEventListener("orientationchange", syncModalViewportHeight);
      if (window.visualViewport) {
        window.visualViewport.addEventListener("resize", syncModalViewportHeight);
        window.visualViewport.addEventListener("scroll", syncModalViewportHeight);
      }
      viewportSyncBound = true;
    }
    if (!modalGestureBound) {
      document.addEventListener("gesturestart", blockNativePinchGesture, { passive: false });
      document.addEventListener("gesturechange", blockNativePinchGesture, { passive: false });
      document.addEventListener("gestureend", blockNativePinchGesture, { passive: false });
      modalGestureBound = true;
    }
    if (modal) modal.style.display = "flex";
    document.body.style.overflow = "hidden";
    resetModalImageZoom();
  }

  function closeModal() {
    if (modalMediaContainer) {
      const v = modalMediaContainer.querySelector("video");
      if (v) v.pause();
    }
    if (modal) modal.style.display = "none";
    if (modal) modal.style.removeProperty("--modal-vh");
    document.body.style.overflow = "";
    resetModalImageZoom();
  }

  function updateImage() {
    if (!modalMediaContainer) return;
    resetModalImageZoom();
    const existingVideo = modalMediaContainer.querySelector("video");
    if (existingVideo) existingVideo.pause();
    modalMediaContainer.innerHTML = "";
    const item = productModalItems[currentIndex];
    if (item && item.type === "video" && item.videoSrc) {
      const video = document.createElement("video");
      video.className = "modal-main-image modal-main-video";
      video.controls = true;
      video.autoplay = true;
      video.playsInline = true;
      video.loop = true;
      if (item.src) video.setAttribute("poster", item.src);
      const source = document.createElement("source");
      source.src = item.videoSrc;
      source.setAttribute("type", "video/mp4");
      video.appendChild(source);
      modalMediaContainer.appendChild(video);
      video.play().catch(function () {});
    } else {
      const img = document.createElement("img");
      img.id = "modal-main-image";
      img.className = "modal-main-image";
      img.loading = "lazy";
      img.src = (item && item.src) || productImages[currentIndex] || "";
      img.alt = "";
      modalMediaContainer.appendChild(img);
      bindModalImageTapZoom(img);
    }
    if (currentIndexSpan) currentIndexSpan.textContent = currentIndex + 1;
  }

  function nextImage() {
    currentIndex = (currentIndex + 1) % productImages.length;
    updateImage();
  }

  function prevImage() {
    currentIndex = (currentIndex - 1 + productImages.length) % productImages.length;
    updateImage();
  }

  if (modalMediaWrapper) {
    let startX = 0, startY = 0;
    modalMediaWrapper.addEventListener("mousedown", function (e) {
      if (modalImageZoomed) return;
      startX = e.clientX;
      startY = e.clientY;
      const onMouseMove = function (e) {
        const dx = e.clientX - startX, dy = e.clientY - startY;
        if (Math.abs(dx) > Math.abs(dy)) {
          document.removeEventListener("mousemove", onMouseMove);
          if (dx > 0) runLTR(); else runRTL();
        }
      };
      document.addEventListener("mousemove", onMouseMove);
      modalMediaWrapper.addEventListener("mouseup", function () {
        document.removeEventListener("mousemove", onMouseMove);
      }, { once: true });
    });
  }

  // 🎯 Replace these with your own logic
  function runLTR() { 
    const mediaBackBtn = document.querySelector("#gallery-modal .pswp__button.modal-prev");
    mediaBackBtn && mediaBackBtn.click()
   }
  function runRTL() { 
    const mediaBackBtn = document.querySelector("#gallery-modal .pswp__button.modal-next");
    mediaBackBtn && mediaBackBtn.click();
   }

  // Single delegated listener for desktop gallery (avoids duplicate handlers when setupDesktopGalleryHandlers runs after variant switch)
  const productGalleryEl = sectionRoot.querySelector(".product-gallery");
  if (productGalleryEl && !productGalleryEl.dataset.galleryClickBound) {
    productGalleryEl.dataset.galleryClickBound = "1";
    productGalleryEl.addEventListener("click", function (e) {
      const container = e.target.closest(".product-image-container:not(.product-image-container--hidden)");
      if (!container) return;
      const target = container.querySelector(".gallery-thumb, .gallery-media-video");
      if (!target) return;
      const containers = sectionRoot.querySelectorAll(".product-gallery .product-image-container:not(.product-image-container--hidden)");
      const index = Array.from(containers).indexOf(container);
        if (target.tagName === "VIDEO" || target.classList.contains("gallery-media-video")) {
        e.preventDefault();
        e.stopPropagation();
        productGalleryEl.querySelectorAll("video.gallery-media-video").forEach(function (v) {
          if (v !== target) {
            v.pause();
            const c = v.closest(".product-image-container");
            if (c) c.classList.remove("is-playing");
          }
        });
        if (target.paused) {
          target.muted = false;
          target.play();
          container.classList.add("is-playing");
        } else {
          target.pause();
          container.classList.remove("is-playing");
        }
      } else {
        openModal(index);
      }
    });
    productGalleryEl.addEventListener("play", function (e) {
      if (e.target.tagName === "VIDEO") {
        const c = e.target.closest(".product-image-container");
        if (c) c.classList.add("is-playing");
      }
    }, true);
    productGalleryEl.addEventListener("pause", function (e) {
      if (e.target.tagName === "VIDEO") {
        const c = e.target.closest(".product-image-container");
        if (c) c.classList.remove("is-playing");
      }
    }, true);
    productGalleryEl.addEventListener("ended", function (e) {
      if (e.target.tagName === "VIDEO") {
        const c = e.target.closest(".product-image-container");
        if (c) c.classList.remove("is-playing");
      }
    }, true);
  }

  // Function to setup desktop gallery (clone thumbs to clear state; click is handled by delegated listener above)
  function setupDesktopGalleryHandlers() {
    const productGallery = sectionRoot.querySelector(".product-gallery");
    if (!productGallery) return;
    sectionRoot.querySelectorAll(".product-gallery .gallery-thumb").forEach((thumb) => {
      const newThumb = thumb.cloneNode(true);
      thumb.parentNode.replaceChild(newThumb, thumb);
    });
  }
  
  // Setup initial handlers (rebuildModalImages/setupDesktopGalleryHandlers are in closure for this section)
  setupDesktopGalleryHandlers();
  
  const mainImageMobile = sectionRoot.querySelector(".main-image");
  if (mainImageMobile) {
    mainImageMobile.addEventListener("click", () => {
      // Rebuild modal images to ensure we have mobile thumbnails on mobile
      rebuildModalImages();
      
      // Find the active thumbnail to determine which image to show
      const activeSlide = sectionRoot.querySelector(".product-thumbs-swiper .swiper-slide.activated");
      let activeIndex = 0;
      
      if (activeSlide) {
        const allSlides = sectionRoot.querySelectorAll(".product-thumbs-swiper .swiper-slide");
        activeIndex = Array.from(allSlides).indexOf(activeSlide);
        if (activeIndex < 0) activeIndex = 0;
      }
      
      openModal(activeIndex);
    });
  }
  if (modal) {
    modal.querySelector(".modal-close").addEventListener("click", closeModal);
    modal.querySelector(".modal-next").addEventListener("click", nextImage);
    modal.querySelector(".modal-prev").addEventListener("click", prevImage);
    modal.addEventListener("click", (e) => {
      if (e.target === modal) closeModal();
    });
    document.addEventListener("keydown", (e) => {
      if (modal.style.display === "flex") {
        if (e.key === "ArrowRight") nextImage();
        if (e.key === "ArrowLeft") prevImage();
        if (e.key === "Escape") closeModal();
      }
    });
  }

  // Sticky add-to-cart: same behaviour as default PDP product-sticky-bar.
  // Show only when .add-to-cart-button has scrolled above viewport, and hide when footer is in view.
  const sectionWrapper = sectionRoot.closest(".shopify-section");
  const sticky = (sectionWrapper || document).querySelector(".sticky-add-to-cart");
  const stickyForm = sticky ? sticky.querySelector("form") : null;
  const stickyInput = stickyForm ? stickyForm.querySelector('input[name="id"]') : null;
  const mainForm = sectionRoot.querySelector(".product-form");
  const atcButton = mainForm ? mainForm.querySelector(".add-to-cart-button") : null;
  const mainInputs = mainForm ? mainForm.querySelectorAll('input[name="id"]') : [];
  const footerSection = document.querySelector(".shopify-section--footer");

  if (window.innerWidth >= 768) {
    return;
  }

  function selectFirstVariantIfNone() {
    if (!mainInputs.length) return;
    const checked = mainForm.querySelector('input[name="id"]:checked');
    if (!checked) {
      mainInputs[0].checked = true;
      mainInputs[0].dispatchEvent(new Event("change", { bubbles: true }));
    }
  }

  function syncVariant() {
    if (!mainForm || !stickyInput) return;
    const checked = mainForm.querySelector('input[name="id"]:checked');
    if (checked) {
      stickyInput.value = checked.value;
    }
  }

  mainInputs.forEach((input) => {
    input.addEventListener("change", syncVariant);
  });

  selectFirstVariantIfNone();
  syncVariant();

  function setStickyVisible(visible) {
    if (!sticky) return;
    sticky.style.display = visible ? "flex" : "none";
  }

  let latestFormCondition = false;
  let latestFooterCondition = false;

  function updateStickyVisibility() {
    setStickyVisible(latestFooterCondition && latestFormCondition);
  }

  function recheckStickyFromRects() {
    if (!atcButton) return;
    const atcRect = atcButton.getBoundingClientRect();
    latestFormCondition = atcRect.bottom < 0;
    if (!footerSection) {
      latestFooterCondition = true;
    } else {
      const footerRect = footerSection.getBoundingClientRect();
      latestFooterCondition = !(footerRect.top < window.innerHeight && footerRect.bottom > 0);
    }
    updateStickyVisibility();
  }

  if (sticky && atcButton) {
    const observer = new IntersectionObserver(
      (entries) => {
        const atcEntry = entries.find((e) => e.target === atcButton);
        const footerEntry = footerSection ? entries.find((e) => e.target === footerSection) : null;
        if (atcEntry) {
          latestFormCondition = !atcEntry.isIntersecting && atcEntry.boundingClientRect.bottom < 0;
        }
        if (footerEntry) {
          latestFooterCondition = !footerEntry.isIntersecting;
        } else if (!footerSection) {
          latestFooterCondition = true;
        }
        updateStickyVisibility();
      },
      { root: null, rootMargin: "0px", threshold: 0 }
    );
    observer.observe(atcButton);
    if (footerSection) {
      observer.observe(footerSection);
    } else {
      latestFooterCondition = true;
    }
    // Initial state
    recheckStickyFromRects();

    // Recheck when DOM changes (e.g. reviews/late content pushing ATC down)
    let recheckTimeout = null;
    const domObserver = new MutationObserver(() => {
      if (recheckTimeout) clearTimeout(recheckTimeout);
      recheckTimeout = setTimeout(recheckStickyFromRects, 100);
    });
    domObserver.observe(sectionRoot, { childList: true, subtree: true });
  } else {
    setStickyVisible(false);
  }

  if (stickyForm) {
    stickyForm.addEventListener("submit", function (e) {
      if (!stickyInput.value) {
        e.preventDefault();
      }
    });
  }

  // Show anchor on scroll
  var anchors = sectionRoot.querySelector(".product-anchors");
  if (!anchors) return;

  function handleAnchorsVisibility() {
    if (window.scrollY > 0) {
      anchors.classList.add("visible");
    } else {
      anchors.classList.remove("visible");
    }
  }

  window.addEventListener("scroll", handleAnchorsVisibility);
  handleAnchorsVisibility();

  // Okendo
  function moveWriteReviewButton() {
    const writeReviewBtn = document.querySelector('.okeReviews-reviewsWidget-header-controls-writeReview');
    const sortContainer = document.querySelector('.okeReviews-reviews-controls-sort');
    if (writeReviewBtn && sortContainer) {
      if (!sortContainer.contains(writeReviewBtn)) {
        sortContainer.appendChild(writeReviewBtn);
      }
      return true;
    }
    return false;
  }

  function moveReviewDates() {
    document.querySelectorAll('.okeReviews-review').forEach(function (review) {
      const date = review.querySelector('.okeReviews-review-date');
      const details = review.querySelector('.okeReviews-review-reviewer-profile-details-inner');
      if (date && details && !details.contains(date)) {
        if (details.children.length > 1) {
          details.insertBefore(date, details.children[1]);
        } else {
          details.appendChild(date);
        }
      }
    });
  }

  function injectSortByWrapper() {
    const selectContainer = document.querySelector('.okeReviews-reviews-controls-select');
    if (selectContainer && !selectContainer.querySelector('.sort-by-wrapper')) {
      const sortByHTML = `
      <div class="sort-by-wrapper">
        <div class="sort-by-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
            <path d="M12 5.08984L20 5.08984M4 19.0898L7 19.0898M4 5.08984L8 5.08984M11 19.0898L20 19.0898M17 12.0898L20 12.0898M4 12.0898L13 12.0898" stroke="#707070" stroke-linecap="round"/>
            <path d="M8 5.08984C8 6.19441 8.89543 7.08984 10 7.08984C11.1046 7.08984 12 6.19441 12 5.08984C12 3.98527 11.1046 3.08984 10 3.08984C8.89543 3.08984 8 3.98527 8 5.08984Z" stroke="#707070" stroke-linecap="round"/>
            <path d="M13 12.0898C13 13.1944 13.8954 14.0898 15 14.0898C16.1046 14.0898 17 13.1944 17 12.0898C17 10.9853 16.1046 10.0898 15 10.0898C13.8954 10.0898 13 10.9853 13 12.0898Z" stroke="#707070" stroke-linecap="round"/>
            <path d="M7 19.0898C7 20.1944 7.89543 21.0898 9 21.0898C10.1046 21.0898 11 20.1944 11 19.0898C11 17.9853 10.1046 17.0898 9 17.0898C7.89543 17.0898 7 17.9853 7 19.0898Z" stroke="#707070" stroke-linecap="round"/>
          </svg>
        </div>
        <div class="sort-by-title">
          Show by
        </div>
      </div>
    `;
      selectContainer.insertAdjacentHTML('afterbegin', sortByHTML);
      return true;
    }
    return false;
  }

  const okendoWidgetContainer = document.getElementById('shopify-product-reviews-eo');
  if (okendoWidgetContainer) {
    const observer = new MutationObserver(() => {
      moveWriteReviewButton();
      moveReviewDates();
      injectSortByWrapper();
    });

    observer.observe(okendoWidgetContainer, {
      childList: true,
      subtree: true,
    });

    moveWriteReviewButton();
    moveReviewDates();
    injectSortByWrapper();
  }

  // Swiper for mobile (if needed)
  function isMobile() {
    return window.innerWidth < 1024;
  }

  function createMobileSwiper() {
    if (document.querySelector('.rebuy-swiper-mobile')) return;
    var splide = document.getElementById('splide02');
    if (!splide) return;
    var swiperContainer = document.createElement('div');
    swiperContainer.className = 'rebuy-swiper-mobile';
    swiperContainer.style.display = 'none';
    swiperContainer.innerHTML = `
      <div class="swiper">
        <div class="swiper-wrapper"></div>
        <div class="swiper-scrollbar"></div>
      </div>
    `;
    splide.parentNode.insertBefore(swiperContainer, splide.nextSibling);
    var slides = splide.querySelectorAll('.rebuy-product-block');
    var swiperWrapper = swiperContainer.querySelector('.swiper-wrapper');
    slides.forEach(function (slide) {
      var clone = slide.cloneNode(true);
      clone.classList.remove('splide__slide', 'rebuy-carousel__slide', 'is-active', 'is-visible', 'is-next');
      clone.classList.add('swiper-slide');
      swiperWrapper.appendChild(clone);
    });
  }

  function showSwiperIfMobile() {
    var splide = document.getElementById('splide02');
    var swiperContainer = document.querySelector('.rebuy-swiper-mobile');
    if (!splide || !swiperContainer) return;
    if (isMobile()) {
      splide.style.display = 'none';
      swiperContainer.style.display = 'block';
      if (!swiperContainer.dataset.inited) {
        new Swiper('.rebuy-swiper-mobile .swiper', {
          slidesPerView: 2,
          spaceBetween: 16,
          scrollbar: {
            el: '.swiper-scrollbar',
            draggable: true,
          },
        });
        swiperContainer.dataset.inited = "1";
      }
    } else {
      splide.style.display = '';
      swiperContainer.style.display = 'none';
    }
  }

  createMobileSwiper();
  showSwiperIfMobile();
  window.addEventListener('resize', function () {
    showSwiperIfMobile();
  });

  }); // end sectionRoots.forEach
});